import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "../lib/api";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="checkout-cancel"
      className="min-h-screen bg-black text-white flex items-center justify-center px-6 grain"
    >
      <div className="max-w-md w-full text-center fade-up">
        <img src={LOGO_URL} alt="" className="h-20 w-20 object-contain mx-auto mb-8" />
        <p className="text-xs uppercase tracking-[0.3em] text-zinc-400 mb-3">
          Checkout cancelled
        </p>
        <h1 className="font-display text-5xl uppercase tracking-tighter mb-6">
          No worries
        </h1>
        <p className="text-zinc-400 mb-8">
          Your cart is still saved. Come back when you're ready.
        </p>
        <button
          onClick={() => navigate("/")}
          data-testid="cancel-home-btn"
          className="bg-green-500 hover:bg-green-400 text-black font-bold uppercase tracking-widest px-8 py-4 transition-colors"
        >
          Back to shop
        </button>
      </div>
    </div>
  );
}
